<template>
    <div class="equipment-info">
        <Title :img="triangleImg" :name="'设备信息'" :callback="getEquipmentInfo" />
        <div class="equipment-info-content">
            <div class="item">
                <div style="flex:1"><img src="@/assets/image/Drone.png" alt=""
                        style="width: 2rem;height: 2rem;margin-right: 5px;">{{ Drone.type }}</div>
                <div style="flex:1;display: flex;align-items: center;">
                    <img src="@/assets/image/normal.png" alt="" style="height: 2rem;margin-right: 5px;">
                    <div>
                        <div style="font-size: 1.5rem;font-weight: 600;font-style: italic;color: #3d5afe;">{{
                            Drone.normal
                            }}</div>
                        <div style="font-size: 0.6rem">正常</div>
                    </div>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <img src="@/assets/image/abnormal.png" alt="" style="height: 2rem;margin-right: 5px;">
                    <div>
                        <div style="font-size: 1.5rem;font-weight: 600;font-style: italic;color: #fed501;">{{
                            Drone.abnormal
                            }}</div>
                        <div style="font-size: 0.6rem">故障</div>
                    </div>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <img src="@/assets/image/total.png" alt="" style="height: 2rem;margin-right: 5px;">
                    <div>
                        <div style="font-size: 1.5rem;font-weight: 600;font-style: italic;color: #13d48d;">{{
                            Drone.total
                            }}</div>
                        <div style="font-size: 0.6rem">总数</div>
                    </div>
                </div>
            </div>

            <div class="item">
                <div style="flex:1"><img src="@/assets/image/PatrolVehicle.png" alt=""
                        style="width: 2rem;height: 2rem;margin-right: 5px;">{{ PatrolVehicle.type }}</div>
                <div style="flex:1;display: flex;align-items: center;">
                    <img src="@/assets/image/normal.png" alt="" style="height: 2rem;margin-right: 5px;">
                    <div>
                        <div style="font-size: 1.5rem;font-weight: 600;font-style: italic;color: #3d5afe;">{{
                            PatrolVehicle.normal
                            }}</div>
                        <div style="font-size: 0.6rem">正常</div>
                    </div>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <img src="@/assets/image/abnormal.png" alt="" style="height: 2rem;margin-right: 5px;">
                    <div>
                        <div style="font-size: 1.5rem;font-weight: 600;font-style: italic;color: #fed501;">{{
                            PatrolVehicle.abnormal
                            }}</div>
                        <div style="font-size: 0.6rem">故障</div>
                    </div>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <img src="@/assets/image/total.png" alt="" style="height: 2rem;margin-right: 5px;">
                    <div>
                        <div style="font-size: 1.5rem;font-weight: 600;font-style: italic;color: #13d48d;">{{
                            PatrolVehicle.total
                            }}</div>
                        <div style="font-size: 0.6rem">总数</div>
                    </div>
                </div>
            </div>

            <div class="item">
                <div style="flex:1"><img src="@/assets/image/camera.png" alt=""
                        style="width: 2rem;height: 2rem;margin-right: 5px;">{{ Camera.type }}</div>
                <div style="flex:1;display: flex;align-items: center;">
                    <img src="@/assets/image/normal.png" alt="" style="height: 2rem;margin-right: 5px;">
                    <div>
                        <div style="font-size: 1.5rem;font-weight: 600;font-style: italic;color: #3d5afe;">{{
                            Camera.normal
                            }}</div>
                        <div style="font-size: 0.6rem">正常</div>
                    </div>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <img src="@/assets/image/abnormal.png" alt="" style="height: 2rem;margin-right: 5px;">
                    <div>
                        <div style="font-size: 1.5rem;font-weight: 600;font-style: italic;color: #fed501;">{{
                            Camera.abnormal
                            }}</div>
                        <div style="font-size: 0.6rem">故障</div>
                    </div>
                </div>
                <div style="flex:1;display: flex;align-items: center;">
                    <img src="@/assets/image/total.png" alt="" style="height: 2rem;margin-right: 5px;">
                    <div>
                        <div style="font-size: 1.5rem;font-weight: 600;font-style: italic;color: #13d48d;">{{
                            Camera.total
                            }}</div>
                        <div style="font-size: 0.6rem">总数</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Title from '@/components/title/title.vue'
import PropertyList from '@/page/property/PropertyList.vue';

export default {
    name: 'EquipmentInfo',
    components: { Title, PropertyList },
    data() {
        return {
            propertyListVisible: false,
            Drone: {
                "type": "无人机",
                "total": 7,
                "normal": 5,
                "abnormal": 2,
            },
            PatrolVehicle: {
                "type": "巡检车",
                "total": 8,
                "normal": 6,
                "abnormal": 2,
            },
            Camera: {
                "type": "摄像头",
                "total": 10,
                "normal": 7,
                "abnormal": 3,
            }
        }
    },
    methods: {
        getEquipmentInfo() {
            this.$router.push({ path: "/asset-manage" });
        },
    }
}
</script>

<style lang="less" scoped>
.equipment-info {
    position: absolute;
    height: 30%;
    width: 100%;
    border-radius: 5px;
    padding: 0.5rem;
    background:
        /* 左上角圆形渐变 */
        radial-gradient(circle at left top, #c8aca2, #171e2127 5%) no-repeat,
        /* 右上角圆形渐变 */
        radial-gradient(circle at right top, #c8aca2, #171e2127 5%) no-repeat,
        /* 中间半透明背景 */
        linear-gradient(to bottom, #171e2127, #171e2127);


    .equipment-info-content {
        height: calc(100% - 2rem);
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .item {
            height: 30%;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #FFF;
            font-size: 0.8rem;
        }
    }
}
</style>